import { render, staticRenderFns } from "./AddAnchorDialog.vue?vue&type=template&id=2e6e0c8e&scoped=true"
import script from "./AddAnchorDialog.vue?vue&type=script&lang=js"
export * from "./AddAnchorDialog.vue?vue&type=script&lang=js"
import style0 from "./AddAnchorDialog.vue?vue&type=style&index=0&id=2e6e0c8e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e6e0c8e",
  null
  
)

export default component.exports